import React from 'react';

import labels from '../../../configuration/labels'
import {onEnter  } from '../../../utilities/accessibility/onEnter'

import '../../../styles/scss/filters/popover-wrapper.scss'

const PopoverWrapper = ({
  children,
  exactMatch,
  exactMatchLabel,
  hasExactMatchOption,
  id,
  onClear,
  onClose,
  onSubmit,
  onToggleExactMatch,
  submitLabel,
  title,
}) => (
  <>
    <div className="popover-wrapper-header">
      <span
        className="popover-wrapper-filter-title"
        aria-label={title}
      >
        {title}
      </span>
      <div
        aria-label={labels.close}
        className="popover-wrapper-filter-close"
        onClick={onClose}
        onKeyDown={(event) => onEnter(event, onClose)}
        role="button"
        tabIndex="0"
      >
        {labels.close}
      </div>
    </div>
    {children}
    <div className="popover-wrapper-footer">
      {hasExactMatchOption && (
        <div className="popover-wrapper-exact-match">
          <input
            id={`${id}-exactMatch`}
            name={`${id}-exactMatch`}
            onChange={onToggleExactMatch}
            onKeyDown={event => onEnter(event, onToggleExactMatch)}
            type="checkbox"
            value={exactMatch}
          />
          <label htmlFor={`${id}-exactMatch`}>
            {exactMatchLabel}
          </label>
        </div>
      )}
      <div className="popover-wrapper-submit-buttons">
        <div
          className="popover-wrapper-submit"
          aria-label={submitLabel}
          onClick={onSubmit}
          onKeyDown={event => onEnter(event, onSubmit)}
          role="button"
          tabIndex="0"
        >
          <span>{submitLabel}</span>
        </div>
        <div
          className="popover-wrapper-clear"
          aria-label={labels.clearAllFilters}
          onClick={onClear}
          onKeyDown={event => onEnter(event, onClear)}
          role="button"
          tabIndex="0"
        >
          <span>{labels.clearAllFilters}</span>
        </div>
      </div>
    </div>
  </>
)

export default PopoverWrapper
